/* eslint-disable camelcase */
import axios from "axios";
import { cropr } from "../adapter";
import { prepareData } from "../utils/sensorUtils";
import { jwtClient } from "./authUtils";

export const REQUEST_SENSOR = "REQUEST_SENSOR";
const requestSensor = () => {
  return {
    type: REQUEST_SENSOR,
  };
};

export const SAVE_SENSOR = "SAVE_SENSOR";
const saveSensor = () => {
  return {
    type: SAVE_SENSOR,
  };
};

export const SAVE_SENSOR_COMPLETE = "SAVE_SENSOR_COMPLETE";
const saveSensorComplete = () => {
  return {
    type: SAVE_SENSOR_COMPLETE,
  };
};

export const SAVE_SENSOR_FAILED = "SAVE_SENSOR_FAILED";
const saveSensorFailed = () => {
  return {
    type: SAVE_SENSOR_FAILED,
  };
};

export const RECEIVE_SENSOR = "RECEIVE_SENSOR";
const receiveSensor = (sensor, domainDays, advice) => {
  return {
    type: RECEIVE_SENSOR,
    sensor,
    domainDays,
    advice,
  };
};

export const FAILED_SENSOR = "FAILED_SENSOR";
const failedSensor = () => {
  return {
    type: FAILED_SENSOR,
  };
};

export const BRUSH_DOMAIN = "BRUSH_CHART";
function brushDomain(domain) {
  return {
    type: BRUSH_DOMAIN,
    domain,
  };
}

export const UPDATE_LATITUDE = "UPDATE_LATITUDE";
function updateLatitude(latitude) {
  return {
    type: UPDATE_LATITUDE,
    latitude,
  };
}

export const UPDATE_LONGITUDE = "UPDATE_LONGITUDE";
function updateLongitude(longitude) {
  return {
    type: UPDATE_LONGITUDE,
    longitude,
  };
}

export const UPDATE_TURNED_OFF = "UPDATE_TURNED_OFF";
function updateTurnedOff() {
  return {
    type: UPDATE_TURNED_OFF,
  };
}

export const UPDATE_DEPTH_VISIBILITY = "UPDATE_DEPTH_VISIBILITY";
function updateDepthVisibility(depth, value) {
  return {
    type: UPDATE_DEPTH_VISIBILITY,
    depth,
    value,
  };
}

export const UPDATE_WARNING_PERCENTAGE = "UPDATE_WARNING_PERCENTAGE";
function updateWarningPercentage(value) {
  return {
    type: UPDATE_WARNING_PERCENTAGE,
    value,
  };
}

export const UPDATE_NAME = "UPDATE_NAME";
function updateName(name) {
  return {
    type: UPDATE_NAME,
    name,
  };
}

export const UPDATE_SOIL_TYPE = "UPDATE_SOIL_TYPE";
function updateSoilType(value, capacity) {
  return {
    type: UPDATE_SOIL_TYPE,
    value,
    capacity,
  };
}

export const UPDATE_FIELD_CAPACITY = "UPDATE_FIELD_CAPACITY";
function updateFieldCapacity(depth, fieldCapacity) {
  return {
    type: UPDATE_FIELD_CAPACITY,
    depth,
    fieldCapacity,
  };
}

export const UPDATE_SHOW_PRECIPITATION = "UPDATE_SHOW_PRECIPITATION";
function updateShowPrecipitation(checked) {
  return {
    type: UPDATE_SHOW_PRECIPITATION,
    checked,
  };
}

export const UPDATE_SHOW_TEMPERATURE = "UPDATE_SHOW_TEMPERATURE";
function updateShowTemperature(checked) {
  return {
    type: UPDATE_SHOW_TEMPERATURE,
    checked,
  };
}

export const UPDATE_SCALE = "UPDATE_SCALE";
function updateScale(depth, capacity) {
  return {
    type: UPDATE_SCALE,
    depth,
    capacity,
  };
}

export const UPDATE_REFILL_POINT = "UPDATE_REFILL_POINT";
function updateRefillPoint(depth, refillPoint) {
  return {
    type: UPDATE_REFILL_POINT,
    depth,
    refillPoint,
  };
}

export const HOVER_CHART = "HOVER_CHART";
function hovered(hovered) {
  return {
    type: HOVER_CHART,
    hovered,
  };
}

export const UPDATE_END_DATE = "UPDATE_END_DATE";
function updateEndDate(date) {
  return {
    type: UPDATE_END_DATE,
    date,
  };
}

export const UPDATE_START_DATE = "UPDATE_START_DATE";
function updateStartDate(date) {
  return {
    type: UPDATE_START_DATE,
    date,
  };
}

export const HOVER_DATE = "HOVER_DATE";
function hoverDate(hoverDate) {
  return {
    type: HOVER_DATE,
    hoverDate,
  };
}

export const TOGGLE_PIN = "TOGGLE_PIN";
function togglePin() {
  return {
    type: TOGGLE_PIN,
  };
}

export const TOGGLE_VISIBLE_DEPTHS = "TOGGLE_VISIBLE_DEPTHS";
function toggleVisibleDepths() {
  return {
    type: TOGGLE_VISIBLE_DEPTHS,
  };
}

export const storeSensor = (sensor, apiUrl) => {
  return async (dispatch) => {
    try {
      var url =
        apiUrl +
        "/api/product/view_settings/:id/?format=json".replace(":id", sensor.viewSettingsId);

      if (sensor.validate()) {
        dispatch(saveSensor());

        await jwtClient.withJWT(async (jwt) => {
          return axios.put(url, prepareData(sensor), {
            headers: { Authorization: "JWT " + jwt },
          });
        });
        dispatch(saveSensorComplete());
      } else {
        dispatch(saveSensorFailed());
      }
    } catch {
      return dispatch(saveSensorFailed());
    }
  };
};

export const fetchSensor = (
  apiUrl,
  sensorId,
  domainDays = 14,
  advice,
  days = "",
  setup,
  setup_revert
) => {
  return async (dispatch) => {
    dispatch(requestSensor());
    try {
      var url =
        apiUrl + "/api/product/installation/:id/?format=json".replace(":id", sensorId) + days;
      if (setup) {
        if (setup_revert) {
          url =
            apiUrl +
            "/api/product/installation/:id/?format=json".replace(
              ":id",
              sensorId + "/revert_auto_setup"
            ) +
            days;
        } else {
          url =
            apiUrl +
            "/api/product/installation/:id/?format=json".replace(":id", sensorId + "/auto_setup") +
            days;
        }
      }
      if (cropr.features.irrigation && cropr.features.irrigation !== 0) {
        url += "&irrigation=true";
      }
      if (cropr.l10n.languageCode) {
        url += "&lang=" + cropr.l10n.languageCode;
      }

      const response = await jwtClient.withJWT((jwt) =>
        axios.get(url, {
          headers: { Authorization: "JWT " + jwt },
        })
      );

      const sensor = response.data;
      return dispatch(receiveSensor(sensor, domainDays, advice));
    } catch {
      return dispatch(failedSensor());
    }
  };
};

const sensorActions = {
  brushDomain,
  hovered,
  hoverDate,
  togglePin,
  updateFieldCapacity,
  updateRefillPoint,
  updateLatitude,
  updateLongitude,
  updateName,
  updateSoilType,
  updateDepthVisibility,
  updateWarningPercentage,
  updateTurnedOff,
  updateScale,
  updateShowPrecipitation,
  updateShowTemperature,
  updateEndDate,
  updateStartDate,
  toggleVisibleDepths,
};

export default sensorActions;
